import gql from "graphql-tag";
import {
  VendorProfileCompact,
  UserTagData,
  SubcontractedDeliveriesData,
} from "@/graphql/fragments";

export const USER_ASSIGNED_TASK_SHOTS_QUERY = gql`
  query UserTaskShotsQuery(
    $shotName: String
    $serviceName: String
    $projectId: SmartID
    $userTagIds: [SmartID]
    $userTaskShotIds: [SmartID]
    $userTaskShotStatuses: [UserTaskShotStatusEnum]
    $limit: Int
    $endCursor: String
  ) {
    userTaskShots(
      shotName: $shotName
      serviceName: $serviceName
      userTagIds: $userTagIds
      userTaskShotIds: $userTaskShotIds
      userTaskShotStatuses: $userTaskShotStatuses
      projectId: $projectId
      first: $limit
      after: $endCursor
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          deadline
          status
          vendorProject {
            id
            project {
              id
              name
            }
          }
          deliverables {
            id
            format {
              id
              format
            }
            spec {
              id
              specification
            }
          }
          userTags {
            id
            ...UserTagData
          }
          assignedUserIds
          artistUserTaskShots {
            id
            user {
              id
              firstName
              lastName
            }
            vendorProject {
              id
            }
            isArtistLead
          }
          taskShot {
            id
            subService {
              id
              name
            }
            subcontractedDeliveries {
              id
              ...SubcontractedDeliveriesData
            }
            awardedBid {
              id
              bidRequest {
                id
                primaryClientOffice {
                  id
                  timezone
                }
              }
            }
            shot {
              id
              name
              frameCount
            }
            task {
              id
              service {
                id
                name
              }
            }
          }
          creator {
            id
            firstName
            lastName
            office {
              id
              company {
                id
                profile {
                  ...VendorProfileCompact
                }
              }
            }
            timezone
          }
        }
      }
    }
  }
  ${VendorProfileCompact}
  ${UserTagData}
  ${SubcontractedDeliveriesData}
`;
